import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'MagnificPopup';

export class dealsDetailed{

	dealsLightBox(): any{
		let _self = this;
		let $openPopupLink:any = $('.deals-sidebar .deals-open-popup-link');

		$openPopupLink.on('click', function() {
			let $dealsItem:any               = $(this);
			let $dealsFromIATA: any          = $dealsItem.attr('data-deals-from-iata');
			let $dealsToCityName: any        = $dealsItem.attr('data-deals-destCity');
			let $dealsToCountryName: any     = $dealsItem.attr('data-deals-destCountry');
			let $dealsToIATA: any            = $dealsItem.attr('data-deals-to-iata');
			let $dealsCurrencyType: any      = $dealsItem.attr('data-deals-currency');
			let $dealsTicketPrice: any       = $dealsItem.attr('data-deals-amount');
			let $dealsCabinClass: any        = $dealsItem.attr('data-deals-cabin');
			let $dealsCabinClassText: any    = $dealsItem.attr('data-deals-cabin-hidden');
			let $dealsTripType: any          = $dealsItem.attr('data-deals-triptype');
			let $dealsTravelStartPeriod: any = $dealsItem.attr('data-deals-travelstartperiod');
			let $dealsTravelEndPeriod: any   = $dealsItem.attr('data-deals-travelendperiod');
			let $dealsTravelTnc: any         = $dealsItem.attr('data-deals-travelTnc');
			let $dealsToCityCode: any        = $dealsItem.attr('data-deal-destCityCode');
			let $dealsfromCity: any          = $dealsItem.attr('data-deal-fromCity');
			let $dealsfromCityCode: any      = $dealsItem.attr('data-deal-fromCityCode');
			let $dealsfromCountry: any       = $dealsItem.attr('data-deal-fromCountry');

			let $dealsPopup:any = $('.deals-popup');
			let $depReturnTitle:any = $('.dep-return--title');

			$depReturnTitle.find('.date-form--title').addClass('input-filled');
			$dealsPopup.find('.city-country--list.from .city-name').html($dealsfromCity);
			$dealsPopup.find('.city-country--list.from .country-name').html($dealsfromCountry);
			$dealsPopup.find('.city-country--list.from .city-name').attr("data-code",$dealsfromCityCode);
			$dealsPopup.find('.city-country--list.from .iata').html('('+$dealsFromIATA+')');
			$dealsPopup.find('.city-country--list.to .city-name').html($dealsToCityName);
			$dealsPopup.find('.city-country--list.to .country-name').html($dealsToCountryName);
			$dealsPopup.find('.city-country--list.to .city-name').attr("data-code", $dealsToCityCode);
			$dealsPopup.find('.city-country--list.to .iata').html('('+$dealsToIATA+')');
			$dealsPopup.find('.currency-price .currency-name').html($dealsCurrencyType);
			$dealsPopup.find('.currency-price .price-amount').html($dealsTicketPrice);
			$dealsPopup.find('.cabin-class--type').html($dealsCabinClass);
			$dealsPopup.find('#cabin-class-hidden').html($dealsCabinClassText);
			$dealsPopup.find('.trip-type').html($dealsTripType);
			$dealsPopup.find('.departureDate').val($dealsTravelStartPeriod);
			$dealsPopup.find('.departureDate').datepicker( 'option', 'minDate', new Date($dealsTravelStartPeriod));
			$dealsPopup.find('.returnDate').datepicker( 'option', 'minDate', new Date($dealsTravelStartPeriod));
			$dealsPopup.find('.returnDate').val($dealsTravelEndPeriod);
			$dealsPopup.find('.departureDate').datepicker( 'option', 'maxDate', new Date($dealsTravelEndPeriod));
			$dealsPopup.find('.returnDate').datepicker( 'option', 'maxDate', new Date($dealsTravelEndPeriod));
			$dealsPopup.find('.tc-content').val($dealsTravelTnc);
		});
		$openPopupLink.magnificPopup({
			type:'inline',
			midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
		});
	}
}


let scope:Element = document.querySelector('.deals-sidebar');
if (scope){
	try {
	let dealsdetailed = new dealsDetailed();
			dealsdetailed.dealsLightBox();
			// dealsdetailed.dealsTandC();
	} catch(e) {console.error(e);}
}
